import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 8a1 1 0 0 1 1 1v8a1 1 0 0 0 1 1h12a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V9a1 1 0 0 1 1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgShareScreenFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ShareScreenFilled_default = SvgShareScreenFilled;

export { ShareScreenFilled_default as default };
